<div class="logo">
  <svg class="symbol" viewBox="0 0 52 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="element-1" d="M0 16C0 7.16344 7.16344 0 16 0H32V16H0V16Z" fill="#4353FF" />
    <path class="element-2" d="M36 0V0C44.8366 0 52 7.16344 52 16V32H36V0Z" fill="#4353FF" />
    <path class="element-3" d="M20 36H52V36C52 44.8366 44.8366 52 36 52H20V36Z" fill="#4353FF" />
    <path class="element-4" d="M0 20H16V52L0 56V20Z" fill="#4353FF" />
  </svg>
</div>
